import { Context, createContext, FC, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import css from './index.module.less';
import {
  AutoCenter,
  Button,
  Checkbox,
  Form,
  Image,
  ImageUploader,
  Input, Modal,
  Picker,
  Selector,
  TextArea,
  Toast
} from 'antd-mobile'
import { useParams } from 'react-router-dom'
import { addOrderApi, getOrderTemplateApi } from '@/api/home'
import { PageLoading } from '@/components/PageLoading'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { isEmpty } from '@/utils'
import { getLngToApi } from '@/utils/getLng'
import { withAuth } from '@/hoc/withAuth'
import {
  DynamicFormItem,
  MODEL_COVER_EXT_PREFIX,
  MODEL_EXT_PREFIX
} from '@/pages/home/AddOrder/components/DynamicFormItem'
import { useNav } from '@/hooks/useNav'
import { BindPhoneModal } from '@/pages/home/AddOrder/components/BindPhoneModal'
import { FormInstance } from 'antd-mobile/es/components/form'
import { isDate, isLooseSelect, isSystemField } from '@/pages/home/AddOrder/utils'

export const FormContext = createContext<FormInstance>(null) // 表单上下文

export const AddOrder: FC = withAuth(props => {
  const { t } = useTranslation();
  const { classId } = useParams();
  const [template, setTemplate] = useState<any>({});
  const [form] = Form.useForm();
  const { nav } = useNav()
  const { role, pageLoading, centerConfig, user, inner }: any = useStoreState();
  const dispatch = useStoreDispatch()
  const [submitting, setSubmitting] = useState(false)
  const [bindPhoneModalVisible, setBindPhoneModalVisible] = useState(false)

  useEffect(() => {
    dispatch({ type: actionTypes.SET_LOGIN_MODAL_CONFIG, payload: { showCloseButton: false } });
  }, []);

  // 获取工单模板
  useEffect(() => {
    const getTemplate = async () => {
      dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true })
      const res = await getOrderTemplateApi({ classId, language: getLngToApi() }).finally(() => dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: false }))
      if (res?.code === 0) {
        setTemplate(res.data);
      }
    }
    user.isLogin && getTemplate()
  }, [user.isLogin])

  // 根据接口返回的模板数据设置默认值
  useEffect(() => {
    const presetModel = { [MODEL_EXT_PREFIX]: {} }
    template.fieldVoList?.map(config => {
      if (isLooseSelect(config) && !Array.isArray(config.presetContext)) config.presetContext = config.presetContext.split(',') || []
      if (isDate(config)) config.presetContext = config.presetContext ? new Date(config.presetContext) : null
      if (config.presetContext) {
        if (isSystemField(config)) {
          presetModel[config.fieldKey] = config.presetContext
        } else {
          presetModel[MODEL_EXT_PREFIX][config.fieldName] = config.presetContext
        }
      }
    })
    form.setFieldsValue(presetModel);
  }, [template])

  // 设置默认值
  useEffect(() => {
    if(!user.isLogin)return
    const model: any = { classId, workOrderSource: inner.isFrom ? 'inner' : 'web' };
    if (!user.bindPhoneFlag && centerConfig.phoneStrategy === 2) dispatch({ type: actionTypes.SET_PHONE_STRATE, payload: true });
    if (inner.isFrom) Object.assign(model, { kfId: inner.kfId });
    if (!isEmpty(role)) Object.assign(model, role);
    form.setFieldsValue(model);
  }, [user.isLogin])

  // 点击提交按钮 要先判断是否绑定了手机号 没有则弹出绑定弹框
  // bindPhoneFlag 联系手机号码，是否已经填写
  const onFinish = async (values) => {
    if (!user.bindPhoneFlag) {
      switch (centerConfig.phoneStrategy) {
        case 1:
        case 2:
          setBindPhoneModalVisible(true)
          break;
        default:
          addOrder()
          break;
      }
    } else {
      addOrder()
    }
  }

  // 创建工单 因为有比如gameCode等不展示出来但有值的话就要传给后端的字段 所以不能用values只能获取全部字段
  // 更新：如果有传入联系手机号 则一起提交 (在绑定手机号弹框中需要用到)
  const addOrder = async (contactPhone?: string) => {
    setSubmitting(true)
    const model = { ...form.getFieldsValue(true), contactPhone, deviceLanguage: getLngToApi() }
    model[MODEL_EXT_PREFIX] = { ...model[MODEL_EXT_PREFIX], ...model[MODEL_COVER_EXT_PREFIX] }
    delete model[MODEL_COVER_EXT_PREFIX]
    const res = await addOrderApi(model).finally(() => setSubmitting(false)).catch(err => err)
    if (res?.code === 0) {
      Toast.show({ icon: 'success', content: `${t('order.toast-1')}` });
      nav('/');
    } else {
      Toast.show({ icon: 'fail', content: `${res.msg}` });
    }
  }


  if (pageLoading) return <PageLoading />;

  return (
    <FormContext.Provider value={form}>
      <div className={css.Page}>

        <div className={css.PageHd}>
          {template.fieldVoList?.length ? (
            <Form className={css.Form} form={form} onFinish={onFinish}>
              {template.fieldVoList?.map(vo => <DynamicFormItem config={vo} key={vo.id} />)}

              <div className={css.BtnSubmitWrap}>
                <Button className={css.BtnSubmit} block type='submit' color='primary' size='large' loading={submitting}>{t('common.submit')}</Button>
              </div>
            </Form>
          ) : <AutoCenter>{t('order.no-more')}</AutoCenter>}
        </div>

        <BindPhoneModal visible={bindPhoneModalVisible} setVisible={setBindPhoneModalVisible} addOrder={addOrder} />
      </div>
    </FormContext.Provider>
  )
})
